import { DomainError } from '../shared/DomainError';
import { isLogicalDate } from '../shared/LogicalDate';

/**
 * Deterministic, offline, content-only selection: the same logical date always yields the
 * same index for a given corpus size. Never depends on journal text, mood, or completion data.
 */
export function selectDailyPhilosophyIndex(logicalDate: string, corpusSize: number): number {
  if (!isLogicalDate(logicalDate)) {
    throw new DomainError('invalid_logical_date', 'Cette date n’est pas valide.');
  }
  if (!Number.isInteger(corpusSize) || corpusSize <= 0) {
    throw new DomainError('empty_philosophy_corpus', 'Aucune pensée n’est disponible.');
  }
  let hash = 0;
  for (let index = 0; index < logicalDate.length; index += 1) {
    hash = (hash * 31 + logicalDate.charCodeAt(index)) >>> 0;
  }
  return hash % corpusSize;
}
